import React, { useEffect, useState } from "react";
import "./ProductTopicItems.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { spinContent } from "../../../services/customData";
import { Button, Form, Modal, Spin, message } from "antd";
import { FormMultiSelect } from "../../FormInputs/FormSelect";
import { getApi, postApi } from "../../../utils/apiServices";
import {
  ADD_TOPIC_ITEM,
  DELETE_TOPIC_ITEM,
  GET_PRODUCTS_VARIENTS_LIST_DROPDOWN,
  GET_TOPIC_ITEMS,
} from "../../../utils/apiPath";
import { IMAGE_BASE_PATH } from "../../../utils/constant";
import { CloseOutlined } from "@ant-design/icons";
import ToastHelper from "../../../services/ToastHelper";

const ProductTopicItems = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const topicData = location.state.topicData;

  const [form] = Form.useForm();
  const [productTopics, setProductTopics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productsList, setProductsList] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [filteredProductsList, setFilteredProductsList] = useState([]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const payload = preparePayload(values?.products);
      const res = await postApi(`${ADD_TOPIC_ITEM}`, payload);
      setLoading(false);
      message.success("Category topic items added successfully");
      form.resetFields();
      setIsModalOpen(false);
      getTopicItems();
    } catch (error) {
      console.error("Validation Error:", error);
    }
  };

  const preparePayload = (values) => {
    const payload = values?.map((id) => ({
      topicType: topicData?.topicType,
      topicId: topicData?.topicId,
      itemId: id,
      topicMediaId: null,
    }));

    return payload;
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleBack = () => {
    navigate("/manage-topics");
  };

  const handleBack1 = () => {
    const data = {
      ...topicData,
      title: topicData?.name
    }
    navigate(`/manage-topics/advertisement/${topicData?.topicId}`, {
      state: { topicData: data },
    });
  };

  useEffect(() => {
    getTopicItems();
    getProductsList();
  }, []);

  const getTopicItems = async () => {
    setLoading(true);
    const payload = {
      topicId: topicData?.topicId,
      topicType: topicData?.topicType,
      topicMediaId: topicData?.topicMediaId || null,
    };
    try {
      const res = await postApi(`${GET_TOPIC_ITEMS}`, payload);
      setProductTopics(res?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching topic items", error);
    }
  };

  const getProductsList = async () => {
    setLoading(true);
    try {
      const res = await getApi(`${GET_PRODUCTS_VARIENTS_LIST_DROPDOWN}`);
      setProductsList(res?.map((item) => ({ label: `${item?.productName} (${item?.color})`, value: item?.productVariantId })));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching topic items", error);
    }
  };

  useEffect(() => {
    if(productsList && productTopics) {
    const filteredProducts = productsList.filter(
      (item) => !productTopics.some((val) => val.itemId === item.value)
    );
    setFilteredProductsList(filteredProducts);
  } else {
    setFilteredProductsList(productsList);
  }
  }, [productsList, productTopics])
  
  const handleDeleteModal = (item) => {
    setDeleteItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setDeleteItem(null);
    setOpen(false);
  };

  const handleDeleteTopicItem = async () => {
    try {
      const payload = {
        itemId: deleteItem?.itemId,
        topicId: topicData?.topicId,
        topicType: topicData?.topicType,
        topicMediaId: null,
      };
      const res = await postApi(`${DELETE_TOPIC_ITEM}`, payload);

      if (res?.statusCode === 200) {
        ToastHelper.success("Product topic deleted successfully");
        handleClose();
        getTopicItems();
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="product-topic">
      <div className="product-topic_container">
        <div className="product-topic_header">
          <div className="product-topic_header_left">
            <h2>Product Topic</h2>
            <div className="product-topic_header_left_links">
              <span onClick={handleBack}>Topics</span>
              {topicData?.name && <span onClick={handleBack1}> / {topicData?.name}</span>}
              <span className="active"> / {topicData?.title}</span>
            </div>
          </div>
          <div className="product-topic_header_right">
            <Button type="primary" onClick={showModal}>
              Add
            </Button>
          </div>
        </div>
        <div className="product-topic_sections">
          <div className="product-topic_cards">
            {productTopics?.length > 0 &&
              productTopics?.map((topic, index) => (
                <div key={index} className="product-topic_card">
                  <div className="product-topic_card_image">
                    <img src={`${IMAGE_BASE_PATH}${topic?.itemImage}`} alt="" />
                    <div
                      className="product-topic_card_close"
                      onClick={() => handleDeleteModal(topic)}
                    >
                      <CloseOutlined />
                    </div>
                  </div>
                  <div className="product-topic_card_content">
                    <h3>{topic?.itemName}</h3>
                  </div>
                </div>
              ))}
          </div>
          {loading ? (
            <div className="product-topic_loading">
              <Spin tip="Loading">{spinContent}</Spin>
            </div>
          ) : (
            productTopics?.length === 0 && <h5>No product topic available</h5>
          )}
        </div>
      </div>
      <Modal
        title="Add"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered={true}
        maskClosable={false}
      >
        <div className="product-topic_modal">
          <Form form={form} layout="vertical">
            <FormMultiSelect
              label="Select products"
              name="products"
              placeholder="Select products"
              rules={[{ required: true }]}
              options={filteredProductsList}
              mode="multiple"
            />
          </Form>
        </div>
      </Modal>
      <Modal
        title="Confirm"
        open={open}
        onOk={handleDeleteTopicItem}
        onCancel={handleClose}
        width={300}
      >
        <p>Are you sure want to delete?</p>
      </Modal>
    </div>
  );
};

export default ProductTopicItems;
